<template>
  <div>
    <CRUDCriteria :showReset="true" :showSearch="false" >
      <template v-slot:criteriaRows>
        <div class="mt-0 ml-6 mr-6 mb-0 pa-0">
          <v-row class="ma-n4">
            <v-col cols="3" class="pt-0 pb-0">
              <CommonDropDowns :isItTaxYear=true @change="dataFromCommonDropDowns"
              :criteriaState="criteriaState"/>
            </v-col>
            <v-col cols="3" class="pt-0 pb-0">
              <v-text-field class="input-text-size" label="Tax ID"
              v-model.number="criteriaState.taxId" type="number" @input="searchByTimeOut" />
            </v-col>
            <v-col cols="3" class="pt-0 pb-0">
              <v-text-field class="input-text-size" label="Name"
              v-model="criteriaState.ownerNameWildCard" @input="searchByTimeOut"
              v-uppercase=globalSettingItem.conEverythingToCaps />
            </v-col>
            <v-col cols="3" class="pt-0 pb-0">
              <v-text-field class="input-text-size" label="Parcel ID"
              v-model="criteriaState.mhPropertyOrParcelId" @input="searchByTimeOut"
              @blur="formatToPidWithDashes('mhPropertyOrParcelId')"
              @focus="formatToPidWith('mhPropertyOrParcelId'), $event.target.select()"
              v-uppercase=globalSettingItem.conEverythingToCaps />
            </v-col>
            <v-col cols="3" class="pt-0 pb-0  mt-n6">
              <v-text-field class="input-text-size" label="VIN"
              v-model="criteriaState.mhVin" @input="searchByTimeOut" />
            </v-col>
            <v-col cols="3" class="pt-0 pb-0  mt-n6">
              <v-text-field class="input-text-size" label="Title"
              v-model="criteriaState.mhTitle" @input="searchByTimeOut"
              v-uppercase=globalSettingItem.conEverythingToCaps />
            </v-col>
            <v-col cols="2" class="pt-0 pb-0  mt-n6">
              <v-text-field class="input-text-size" label="Decal"
              v-model="criteriaState.mhDecal" @input="searchByTimeOut" />
            </v-col>
            <v-col cols="2" class="pt-0 pb-0  mt-n6">
              <v-text-field class="input-text-size" label="Tag Number"
              v-model="criteriaState.mhTag" @input="searchByTimeOut" />
            </v-col>
            <v-col cols="2" class="pt-0 pb-0  mt-n6">
              <v-text-field class="input-text-size" label="Adjustment Number"
              v-model.number="criteriaState.certNumber" @input="searchByTimeOut" type="number" />
            </v-col>
          </v-row>
        </div>
      </template>
    </CRUDCriteria>
  </div>
</template>

<script>
import { mapMutations, mapGetters, mapState } from 'vuex';
import CRUDCriteria from '../../../common/base/crud-2.0/CRUDCriteria.vue';
import CommonDropDowns from '../../common-utils/CommonDropDowns.mixin.vue';
import { SEARCH_DEBOUNCE_TIMER } from '../../common-utils/constants';
import { makeCriteriaStateNullIfEmptyString } from '../../common-utils/CommonTaxFunctionalities';
import GlobalToCaps from '../../../../util/shared/GlobalToCaps.mixin.vue';
import { pIdFormat } from '../../../../util/shared/vue-global';
import '../../../../assets/style.css';

export default {
  name: 'MobileHomeCriteria',
  mixins: [GlobalToCaps],
  props: {
    baseCrudKey: {
      type: String,
      default: '',
    },
  },
  components: {
    CRUDCriteria,
    CommonDropDowns,
  },
  data: () => ({
    delayTimerId: null,
  }),
  created() {
  },
  computed: {
    ...mapGetters('base/crud', ['criteria']),
    ...mapState({
      taxSettingItem: (state) => state.SystemConfig.taxSettingItem,
      globalSettingItem: (state) => state.SystemConfig.globalSettingItem,
    }),
    criteriaState: {
      get() {
        return this.criteria(this.baseCrudKey);
      },
      set(value) {
        this.setCriteria([this.baseCrudKey, value]);
      },
    },
  },
  methods: {
    ...mapMutations('base/crud', [
      'setIsVisible',
      'setCriteria',
    ]),
    searchByTimeOut() {
      clearTimeout(this.delayTimerId);
      this.delayTimerId = setTimeout(async () => {
        this.searchByCriteria();
      }, SEARCH_DEBOUNCE_TIMER);
    },
    dataFromCommonDropDowns(val, whichField) {
      this.criteriaState[whichField] = val;
      this.searchByCriteria();
    },
    searchByCriteria() {
      const returnCriteria = makeCriteriaStateNullIfEmptyString(this.criteriaState);
      const sortByAllTaxYear = [{ column: 'taxYear', direction: 'desc' }, { column: 'taxId', direction: 'asc' }];
      const sortByTaxId = [{ column: 'taxId', direction: 'desc' }];
      if (!returnCriteria.taxYear) returnCriteria.sortBy = sortByAllTaxYear;
      else returnCriteria.sortBy = sortByTaxId;
      this.criteriaState = { ...returnCriteria };
      this.$emit('loadCRUDList');
    },
    formatToPidWithDashes(val) {
      const criteriaVal = this.criteriaState[val] || '';
      // to check is the isDoPidEntry is true and also is it a taxid or PID
      if (this.taxSettingItem.isDoPidEntry) {
        const formatPidPositions = this.taxSettingItem.pidValue || '';
        const formattedPid = pIdFormat(criteriaVal, formatPidPositions);
        this.criteriaState[val] = formattedPid;
      }
    },
    formatToPidWith(val) {
      const criteriaVal = this.criteriaState[val] || '';
      if (this.taxSettingItem.isDoPidEntry) {
        let formatedPid = null;
        if (criteriaVal) formatedPid = criteriaVal.replace(/-/g, '');
        this.criteriaState[val] = formatedPid;
      }
    },
  },
};
</script>
